<template>
  <div class="topBar">
    <el-row>
      <el-col :span="1">
        <div class="save-btn"  @click="goBack()">
        <i class="el-icon-caret-left"  >
          <span>返回</span>
        </i>
        </div>
      </el-col>
      <el-col :span="21">{{scenename}}</el-col>
      <div class="save-btns">
        <div class="save-btn"  @click="save()">
          <i class="el-icon-receiving"></i>
          <span>保存</span>
        </div>
        <div class="save-btn" @click="goPreview()">
          <i class="el-icon-caret-right" ></i>
          <span>预览</span>
        </div>
      </div>
    </el-row>
  </div>
</template>
<style scoped>
.topBar {
  /* width: 100%;
    height:40px;
    position: relative;
    background-color: #333333;
    border: 2px solid #4b4b4b;
    border-bottom: 2px solid #000000;
    box-sizing: border-box;
    color:#fff; */
  -webkit-box-flex: 0;
  -ms-flex: 0 0 40px;
  flex: 0 0 40px;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
}
.el-row {
  height: 36px;
  padding: 0;
  margin: 0;
}
.el-col {
  height: 36px;
  line-height: 36px;
  font-size: 20px;
}
.save-btns {
  height: 100%;
  width: 120px;
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.save-btn {
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 36px;
  font-size: 15px;
  cursor: pointer;
}
.el-icon-receiving{
  margin-right: 5px;
  font-size: 24px;
}
.el-icon-caret-right {
  font-size: 24px;

}
</style>
<script>
export default {
  name: '',
  components: {},
  props: ['scenename'],
  data() {
    return {}
  },
  created() {},
  methods: {
    goBack() {
      this.$router.push({ path: '/my/product' })
    },
    save() {
      this.$parent.saveData()
    },
    goPreview() {
      this.$parent.preView()
    }
  }
}
</script>
